export default {
	methods:{
		prompt_dlg(title,fd_title,fd_nm,test){
    		return new Promise((resove,reject)=>{
	    		let dlg_conf = {
	    			title,
	    			fields:[{
						title       :fd_title,
						placeholder :fd_title,
						type        :"string",
						value       : '',
						name        :fd_nm,
						err_msg     :[]
	    			}],
	    			action :({close,self,type})=>{
	    				if(type=='cancel') return reject('cancel');
	    				// debugger
	    				// self.doing = true;
	    				let value = dlg_conf.fields[0].value.trim();
	    				if(!test) return resove(value);

	    				if(test(value,self)){
	    					resove(value);
			                self.close_dialog();
	    				}
			                // if (typeof(rang) == "undefined" || (rang && 1 * value >= rang[0] && 1 * value <= rang[1])){
			                //     resove(value);
			                //     self.close_dialog();
			                // }else{
			                // 	self.set_errmsg("输入范围不正确")
			                // 	reject('input error')；
			                // }
			            else {
	    					reject('input error') 
	    				}
	    			}
	    		}
	    		this.$store.commit('USER_INPUT_FIELDS',dlg_conf)
    		})
    	}
	}
}


// WEBPACK FOOTER //
// ./src/views/front_sale/mixin/mix_prompt_dlg.js